import React, { useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Tooltip,
    IconButton,
    Typography, Button, Card,
} from "@mui/material";
import {BadgeAlert, Check, CheckCheck} from "lucide-react";
import {useTranslation} from "react-i18next";
import CardContent from "@mui/material/CardContent";
import {defaultVariables} from "../../../config";
import AudioPlayer from "./AudioPlayer";
import ImageViewer from "./ImageViewer";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {connect} from "trim-redux";
import clsx from "clsx";
import {getDisplayTime} from "../../../config/values";

const ChatItem = ({msg,user,first_id}) => {
    const { t } = useTranslation();
    let is_sender = false;
    if(!!first_id){
        is_sender = msg.sender_id === first_id;
    }else{
        is_sender = msg.sender_id === user.id;
    }
    return (
        <Card key={msg.id} className={clsx("chat-item",is_sender ? "sender" : "receiver")}>
            <CardContent>
                <Typography variant="subtitle2" color="textSecondary">
                    {msg.sender?.first_name} {msg.sender?.last_name}
                </Typography>
                {
                    msg.is_read === 0 ?
                    <Check className="lucide-icon-gray chat-status"/>
                        :
                    <CheckCheck className="lucide-icon-secondary chat-status"/>

                }
                {msg.type === "text" && <Typography>{msg.message}</Typography>}
                {msg.type === "image" &&
                    <ImageViewer
                        src={`${defaultVariables.uploads}${msg.message}`}
                        alt="chat image"
                        className="gallery-image"
                    />
                }
                {msg.type === "audio" &&
                    <div style={{marginTop:5}}>
                        <audio
                            controls src={`${defaultVariables.uploads}${msg.message}`}
                            style={{ width: "100%" }}
                            controlsList="nodownload"
                        />
                    </div>
                }
                <Typography variant="body2" color="textSecondary" style={{marginTop:10}}>
                    {getDisplayTime(msg.created_at)}
                </Typography>
            </CardContent>
        </Card>
    );
};

const mapStateToProps = (state) => ({
    user: state.user,
});

export default withStyles(Styles)(connect(mapStateToProps)(ChatItem));